export default "__VITE_ASSET__DvMV_Sa___"